import { useStyles } from "./nav-styles";
import { useHistory } from "react-router";
import { BaixasStorageKeys, useBaixasStorage } from "../../../services/use-cases/baixas-storage";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useSessaoAtual } from "../../../services/providers/sessao-atual-provider/sessao-atual-provider";

export const Nav = (props: any) => {
    const classes = useStyles()
    const history = useHistory()
    const { getRegister } = useBaixasStorage()
    const { Logout } = useSessaoAtual()
    const data = getRegister(BaixasStorageKeys.dataRepresentante)
    return (
        <div className={classes.root}>
            <div className={classes.container}>
                {props.btnLogout && (
                        <button className={classes.btnLogout} onClick={() => Logout(1)}><ExitToAppIcon style={{ color: '#FFF' }} /></button>
                )}
                {props.btnVoltarShow && (
                    <button onClick={() => history.push(props.voltar)} className={classes.btnVoltar}>
                        <ArrowBackIosIcon style={{ color: '#FFF' }} />
                    </button>
                )}
                <span className={classes.title}>{!props.title ? data.nome : props.title}</span>
            </div>
        </div>
    )
}